import { MUI } from 'ci-esi-web-shared';

import { SpEstimateData } from './SpEstimateData';

export function SpEstimate() {
  return (
    <MUI.Box sx={{ marginBottom: '8px' }}>
      <SpEstimateData />
    </MUI.Box>
  );
}
